import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    //  paddingBottom:50,
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1"
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
}));

export default function ActivitiesDialog({ name, columns, rows, closeDialog }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "1600px",
            maxWidth: "none",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "1000px",
              height: "100%",
              minWidth: "600px",
              maxHeight: "700px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 0,
          }}
        >
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <Box
          pt={1}
          pb={1}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography variant="h1" style={{ fontSize: 20 }}>
            {name} Activities
          </Typography>
        </Box>

        <DialogContent>
          <div
            style={{
              width: "100%",
            //  height: `${rows.length * 40 + 70}px`,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              sx={{
                "& .MuiDataGrid-row:first-of-type": {
                  borderTop: "2px solid lightGray",
                },
                "& .MuiDataGrid-cell:has(.row-span-empty)": {
                  borderTop: "none !important",
                },
                "& .MuiDataGrid-cell:has(.row-span-event-empty)": {
                  display: "none !important",
                },
                "& .MuiDataGrid-cell": {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
                "& .period-cell": {
                  borderRight: "2px solid lightGray",
                },
              }}
              showCellRightBorder={true}
              hideFooter={true}
              getRowId={(row) => row.id}
              getCellClassName={(params) => {
                if (
                  ["period"].includes(params.field)
                ) {
                  return "period-cell";
                }
                return "";
              }}
              rowHeight={40}
              disableVirtualization
              autoHeight={true}
            />
          </div>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleClose}
            >
              OK
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
